/**
 * R3 (LPP-21950, VB-01): perimetro commerciale delle operazioni accessori post-firma.
 *
 * Gli abbonamenti (segmento `SUB`, CarBox incluso) e le pratiche a credito pieno (`FULL_CREDIT`,
 * sia B2B sia Tour Operator) sono esclusi: su questi RA i pulsanti di aggiunta e rimozione accessori
 * non vengono mostrati nel dettaglio RA.
 *
 * Il backend applica la stessa regola in `PostSaleSegmentRules` (NTW), sia per rifiutare le
 * operazioni sia per non esporre il catalogo vendibile: qui si evita all'operatore di vedere un
 * pulsante che porterebbe a una richiesta rifiutata. Le due implementazioni vanno tenute allineate;
 * il backend resta la fonte autoritativa, questa e' solo la resa dell'interfaccia.
 */

/** Segmento abbonamento: comprende tutte le categorie, CarBox inclusa. */
export const SEGMENT_SUBSCRIPTION = 'SUB';

/** Credito pieno: la spesa e' a carico del convenzionato, non addebitabile al cliente al banco. */
export const CREDIT_TYPE_FULL_CREDIT = 'FULL_CREDIT';

/**
 * `true` se sul RA sono ammesse le operazioni accessori post-firma.
 *
 * Con segmento e tipo di credito entrambi assenti ritorna `true`: l'interfaccia non nasconde
 * funzioni per un dato mancante, e il backend rifiuta comunque se il caso e' fuori perimetro.
 */
export const isPostSignAllowedForSegment = (segment?: string | null, creditType?: string | null): boolean =>
	segment !== SEGMENT_SUBSCRIPTION && creditType !== CREDIT_TYPE_FULL_CREDIT;
